import { useTranslation } from "react-i18next";
import { useAxios } from "../useAxios";
import { useQuery } from "@tanstack/react-query";
import { LevelBOverallStatistics, LevelBReportFilter } from "../../types/levelb-reports";

export const useGetLevelBStatistics = (filter: LevelBReportFilter, enabled = true) => {
    const axios = useAxios();
    const { t } = useTranslation();

    const fetchStatistics = async (): Promise<LevelBOverallStatistics> => {
        try {
            const params = new URLSearchParams({
                startDate: filter.startDate,
                endDate: filter.endDate,
            });
            
            if (filter.examTermId) {
                params.append('examTermId', filter.examTermId);
            }
            if (filter.examId) {
                params.append('examId', filter.examId);
            }

            const { data } = await axios.get(`/api/levelbreports/statistics?${params.toString()}`);
            return data;
        } catch (error) {
            throw new Error(t("levelBReports.errors.getStatistics"));
        }
    };

    return useQuery({
        queryKey: ["levelBStatistics", filter],
        queryFn: fetchStatistics,
        enabled: enabled && Boolean(filter.startDate) && Boolean(filter.endDate),
    });
};

